import { showFlashToast } from "mixins/flash";

const displaySuccessFlash = function () {
  $(document).ajaxComplete(function (event, jqxhr, settings) {
    if (settings.method == "GET" || settings.type == "GET") {
      return;
    }

    const response = jqxhr.responseJSON;
    if (!response || !response.flash) {
      return;
    }

    Object.keys(response.flash).forEach((type) => {
      const message = response.flash[type];
      showFlashToast(message, {
        type,
        timer: 20000,
        allow_dismiss: true,
      });
    });
  });
};

const displayErrorFlash = function () {
  $(document).ajaxError(function (event, jqxhr, settings) {
    const response = jqxhr.responseJSON;
    if (jqxhr.status !== 403 || !response || !response.flash) {
      return;
    }

    Object.keys(response.flash).forEach((type) => {
      const message = response.flash[type];
      showFlashToast(message, {
        type,
        timer: 20000,
        allow_dismiss: true,
      });
    });
  });
};

export { displaySuccessFlash, displayErrorFlash };
